import { render, staticRenderFns } from "./PedidosTransmitidos.vue?vue&type=template&id=bb5a011a"
import script from "./PedidosTransmitidos.vue?vue&type=script&lang=js"
export * from "./PedidosTransmitidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports